// /* Page ADN */
// jQuery(document).ready(function () {
//   /* bloc text resize  */
//   if ($(".blocadn").length > 0) {
//     function resizeAdn() {
//       var currentsize = $(".blocadn_textareaContainer").width();
//       $(".blocadn_textareaContainer").css("height", currentsize);
//     }
//     resizeAdn();
//     window.onresize = resizeAdn;

//     /* cards resize  */

//     function resizeCard() {
//       if (window.matchMedia("(max-width: 1023px)").matches) {
//         var currentsize = $(".cardsautoplace_item-mobile").width();
//       } else {
//         var currentsize = $(".cardsautoplace_item").width();
//       }
//       $(".cardsautoplace_item").css("height", currentsize);
//     }
//     resizeCard();
//     window.onresize = resizeCard;

//     /* Card change position of %2 items */

//     $(".cardsautoplace_items:nth-child(2)").addClass(
//       "cardsautoplace_items-right"
//     );

    
//   }
// });
